import { Notice } from '@/components/ui/notice';

export function StripeWarning({ className }: { className?: string }) {
  return (
    <Notice tone="warning" className={className}>
      This account pays through an existing Stripe subscription. A discount change applies to future checkouts
      only; change the current subscription's coupon in the Stripe Dashboard.
    </Notice>
  );
}
